import React from "react";
import { Box } from "@mui/material";
import TopNav from "./Menu";

const Base = ({ children }) => (
  <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", bgcolor: "background.default" }}>
    <TopNav />
    <Box
      component="main"
      sx={{
        flex: 1,
        p: { xs: 2, md: 3, lg: 3.5, xl: 4, xxl: 5 },
        overflow: "auto",
        maxWidth: { xl: "1900px", xxl: "2700px" },
        mx: "auto",
        width: "100%",
      }}
    >
      {children}
    </Box>
  </Box>
);

export default Base;
